import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Mongo Sort Index */
  SortKey: any;
};

export enum BodyType {
  coupe = 'coupe',
  crossover = 'crossover',
  hatchback = 'hatchback',
  other = 'other',
  sedan = 'sedan',
  suv = 'suv',
  truck = 'truck',
  unknown = 'unknown',
  van = 'van',
  wagon = 'wagon',
}

export type CarSpec = {
  __typename?: 'CarSpec';
  bodyType: BodyType;
  cylinderType: CylinderType;
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  doorType: DoorType;
  drivetrainType: DrivetrainType;
  fuelType: FuelType;
  id: Scalars['String'];
  make: Scalars['String'];
  model: Scalars['String'];
  transmissionType: TransmissionType;
  trim: Scalars['String'];
  year: Scalars['Int'];
};

export type CarSpecAdd_Input = {
  bodyType: BodyType;
  cylinderType: CylinderType;
  doorType: DoorType;
  drivetrainType: DrivetrainType;
  fuelType: FuelType;
  make: Scalars['String'];
  model: Scalars['String'];
  transmissionType: TransmissionType;
  trim: Scalars['String'];
  year: Scalars['Int'];
};

export type CarSpecUpdate_Input = {
  bodyType?: InputMaybe<BodyType>;
  cylinderType?: InputMaybe<CylinderType>;
  doorType?: InputMaybe<DoorType>;
  drivetrainType?: InputMaybe<DrivetrainType>;
  fuelType?: InputMaybe<FuelType>;
  id: Scalars['String'];
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  transmissionType?: InputMaybe<TransmissionType>;
  trim?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type CarSpec_Add = {
  __typename?: 'CarSpec_Add';
  bodyType: BodyType;
  cylinderType: CylinderType;
  doorType: DoorType;
  drivetrainType: DrivetrainType;
  fuelType: FuelType;
  id?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  transmissionType: TransmissionType;
  trim: Scalars['String'];
  year: Scalars['Int'];
};

export enum CylinderType {
  n2 = 'n2',
  n3 = 'n3',
  n4 = 'n4',
  n5 = 'n5',
  n6 = 'n6',
  n8 = 'n8',
  n10 = 'n10',
  n12 = 'n12',
  na = 'na',
  other = 'other',
  rotary = 'rotary',
  unknown = 'unknown',
}

export type DistinctCarKey = {
  __typename?: 'DistinctCarKey';
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type DistinctResult = {
  __typename?: 'DistinctResult';
  field1: Scalars['String'];
  field2?: Maybe<Scalars['String']>;
  field3?: Maybe<Scalars['String']>;
};

export enum DoorType {
  n2 = 'n2',
  n3 = 'n3',
  n4 = 'n4',
  n5 = 'n5',
  other = 'other',
  unknown = 'unknown',
}

export enum DrivetrainType {
  awd = 'awd',
  fwd = 'fwd',
  n4wd = 'n4wd',
  other = 'other',
  rwd = 'rwd',
  unknown = 'unknown',
}

export enum FilterOperator {
  and = 'and',
  between = 'between',
  eq = 'eq',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  near = 'near',
  or = 'or',
  regex = 'regex',
}

export type FilterParam = {
  boolVal?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<FilterParam>>;
  geoParam?: InputMaybe<GeoParam>;
  intVal?: InputMaybe<Scalars['Int']>;
  intVals?: InputMaybe<Array<Scalars['Int']>>;
  /** default=$Eq */
  operator?: InputMaybe<FilterOperator>;
  strVal?: InputMaybe<Scalars['String']>;
  strVals?: InputMaybe<Array<Scalars['String']>>;
};

export enum FuelType {
  diesel = 'diesel',
  electric = 'electric',
  flex = 'flex',
  gas = 'gas',
  hybrid = 'hybrid',
  hydrogen = 'hydrogen',
  other = 'other',
  unknown = 'unknown',
}

export type GeoLocation = {
  __typename?: 'GeoLocation';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GeoLocation_Input = {
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GeoParam = {
  distance: Scalars['Int'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Listing = {
  __typename?: 'Listing';
  bodyType: Scalars['String'];
  bodyTypeOther?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  colorType: Scalars['String'];
  colorTypeOther?: Maybe<Scalars['String']>;
  conditionType: Scalars['String'];
  cylinderType: Scalars['String'];
  cylinderTypeOther?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteDate: Scalars['String'];
  deleteFlag?: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  doorType: Scalars['String'];
  doorTypeOther?: Maybe<Scalars['String']>;
  drivetrainType: Scalars['String'];
  drivetrainTypeOther?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expireDate: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  fuelType: Scalars['String'];
  fuelTypeOther?: Maybe<Scalars['String']>;
  geoLocation?: Maybe<GeoLocation>;
  heading: Scalars['String'];
  id: Scalars['String'];
  images: Array<ListingImage>;
  listingDate: Scalars['String'];
  make: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  showContactInfo?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusDate: Scalars['String'];
  titleStatus: Scalars['String'];
  transmissionType: Scalars['String'];
  transmissionTypeOther?: Maybe<Scalars['String']>;
  trim: Scalars['String'];
  trimId: Scalars['String'];
  userId: Scalars['String'];
  viewCount?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
  zipCode: Scalars['String'];
};

export type ListingAdd_Input = {
  bodyType: Scalars['String'];
  bodyTypeOther?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  colorType: Scalars['String'];
  colorTypeOther?: InputMaybe<Scalars['String']>;
  conditionType: Scalars['String'];
  cylinderType: Scalars['String'];
  cylinderTypeOther?: InputMaybe<Scalars['String']>;
  deleteDate?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  doorType: Scalars['String'];
  doorTypeOther?: InputMaybe<Scalars['String']>;
  drivetrainType: Scalars['String'];
  drivetrainTypeOther?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  fuelType: Scalars['String'];
  fuelTypeOther?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<GeoLocation_Input>;
  heading: Scalars['String'];
  images: Array<ListingImageUpdate_Input>;
  listingDate?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  showContactInfo?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  statusDate: Scalars['String'];
  titleStatus: Scalars['String'];
  transmissionType: Scalars['String'];
  transmissionTypeOther?: InputMaybe<Scalars['String']>;
  trim: Scalars['String'];
  trimId: Scalars['String'];
  userId: Scalars['String'];
  year: Scalars['Int'];
  zipCode: Scalars['String'];
};

export type ListingImage = {
  __typename?: 'ListingImage';
  external: Scalars['Boolean'];
  id: Scalars['String'];
  location: Scalars['String'];
  order: Scalars['Int'];
  primary: Scalars['Boolean'];
};

export type ListingImageUpdate_Input = {
  external: Scalars['Boolean'];
  id: Scalars['String'];
  location: Scalars['String'];
  order: Scalars['Int'];
  primary: Scalars['Boolean'];
};

export type ListingImageUpdate_Upload = {
  content: Scalars['String'];
  id: Scalars['String'];
};

export type ListingImage_UploadResult = {
  __typename?: 'ListingImage_UploadResult';
  id: Scalars['String'];
  location: Scalars['String'];
};

export type ListingSearchAggregates = {
  __typename?: 'ListingSearchAggregates';
  count?: Maybe<Scalars['Int']>;
  mileageMax?: Maybe<Scalars['Int']>;
  mileageMin?: Maybe<Scalars['Int']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  yearMax?: Maybe<Scalars['Int']>;
  yearMin?: Maybe<Scalars['Int']>;
};

export type ListingSearchResult = {
  __typename?: 'ListingSearchResult';
  aggregates: ListingSearchAggregates;
  listings: Array<Listing>;
};

export type ListingUpdate_Input = {
  bodyType?: InputMaybe<Scalars['String']>;
  bodyTypeOther?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  colorType?: InputMaybe<Scalars['String']>;
  colorTypeOther?: InputMaybe<Scalars['String']>;
  conditionType?: InputMaybe<Scalars['String']>;
  cylinderType?: InputMaybe<Scalars['String']>;
  cylinderTypeOther?: InputMaybe<Scalars['String']>;
  deleteDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  doorType?: InputMaybe<Scalars['String']>;
  doorTypeOther?: InputMaybe<Scalars['String']>;
  drivetrainType?: InputMaybe<Scalars['String']>;
  drivetrainTypeOther?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<Scalars['String']>;
  fuelTypeOther?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<GeoLocation_Input>;
  heading?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  images?: InputMaybe<Array<ListingImageUpdate_Input>>;
  listingDate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  showContactInfo?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusDate?: InputMaybe<Scalars['String']>;
  titleStatus?: InputMaybe<Scalars['String']>;
  transmissionType?: InputMaybe<Scalars['String']>;
  transmissionTypeOther?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  trimId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewCount?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type LocalGeoParam = {
  __typename?: 'LocalGeoParam';
  distance?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Int']>;
};

export type Make = {
  __typename?: 'Make';
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  popular?: Maybe<Scalars['Boolean']>;
};

export type MakeAdd_Input = {
  name: Scalars['String'];
  popular?: InputMaybe<Scalars['Boolean']>;
};

export type MakeUpdate_Input = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  popular?: InputMaybe<Scalars['Boolean']>;
};

export type Make_Add = {
  __typename?: 'Make_Add';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  popular?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  carSpecsAdd: CarSpec_Add;
  carSpecsDelete: Scalars['Int'];
  carSpecsUpdate: Scalars['Int'];
  listingsAdd: Listing;
  listingsAddView: Scalars['Int'];
  listingsContactSeller: Scalars['Boolean'];
  listingsDelete: Scalars['Int'];
  listingsUpdate: Listing;
  listingsUploadImages: Array<ListingImage_UploadResult>;
  makesAdd: Make_Add;
  makesDelete: Scalars['Int'];
  makesUpdate: Scalars['Int'];
  scrapesAdd: Scrape_Add;
  scrapesDelete: Scalars['Int'];
  scrapesUpdate: Scalars['Int'];
  usersAddFavorite: UserActionResult;
  usersAddSavedSearch: UserActionResult;
  usersChangePassword: UserActionResult;
  usersCheckVerified: UserActionResult;
  usersDelete: Scalars['Int'];
  usersDeleteByEmail: UserActionCode;
  usersLogin: UserActionResult;
  usersRegister: UserActionResult;
  usersRemoveFavorite: UserActionResult;
  usersRemoveSavedSearch: UserActionResult;
  usersResetPassword: UserActionCode;
  usersUpdate: User;
  usersVerifyEmail: UserActionCode;
  usersVerifyEmailCode: UserActionResult;
  usersVerifyPasswordCode: UserActionResult;
  zipCodesAdd: ZipCode_Add;
  zipCodesDelete: Scalars['Int'];
  zipCodesUpdate: Scalars['Int'];
};

export type MutationCarSpecsAddArgs = {
  object: CarSpecAdd_Input;
};

export type MutationCarSpecsDeleteArgs = {
  id: Scalars['String'];
};

export type MutationCarSpecsUpdateArgs = {
  object: CarSpecUpdate_Input;
};

export type MutationListingsAddArgs = {
  object: ListingAdd_Input;
};

export type MutationListingsAddViewArgs = {
  listingId: Scalars['String'];
};

export type MutationListingsContactSellerArgs = {
  listingId: Scalars['String'];
  message: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationListingsDeleteArgs = {
  id: Scalars['String'];
};

export type MutationListingsUpdateArgs = {
  object: ListingUpdate_Input;
};

export type MutationListingsUploadImagesArgs = {
  uploads: Array<ListingImageUpdate_Upload>;
};

export type MutationMakesAddArgs = {
  object: MakeAdd_Input;
};

export type MutationMakesDeleteArgs = {
  id: Scalars['String'];
};

export type MutationMakesUpdateArgs = {
  object: MakeUpdate_Input;
};

export type MutationScrapesAddArgs = {
  object: ScrapeAdd_Input;
};

export type MutationScrapesDeleteArgs = {
  id: Scalars['String'];
};

export type MutationScrapesUpdateArgs = {
  object: ScrapeUpdate_Input;
};

export type MutationUsersAddFavoriteArgs = {
  id: Scalars['String'];
  listingId: Scalars['String'];
};

export type MutationUsersAddSavedSearchArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
  searchParams: Scalars['String'];
};

export type MutationUsersChangePasswordArgs = {
  id: Scalars['String'];
  password: Scalars['String'];
};

export type MutationUsersCheckVerifiedArgs = {
  email: Scalars['String'];
};

export type MutationUsersDeleteArgs = {
  id: Scalars['String'];
};

export type MutationUsersDeleteByEmailArgs = {
  email: Scalars['String'];
};

export type MutationUsersLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationUsersRegisterArgs = {
  object: UserAdd_Input;
};

export type MutationUsersRemoveFavoriteArgs = {
  id: Scalars['String'];
  listingId: Scalars['String'];
};

export type MutationUsersRemoveSavedSearchArgs = {
  itemId: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationUsersResetPasswordArgs = {
  email: Scalars['String'];
};

export type MutationUsersUpdateArgs = {
  object: UserUpdate_Input;
};

export type MutationUsersVerifyEmailArgs = {
  email: Scalars['String'];
};

export type MutationUsersVerifyEmailCodeArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type MutationUsersVerifyPasswordCodeArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type MutationZipCodesAddArgs = {
  object: ZipCodeAdd_Input;
};

export type MutationZipCodesDeleteArgs = {
  id: Scalars['String'];
};

export type MutationZipCodesUpdateArgs = {
  object: ZipCodeUpdate_Input;
};

export type Query = {
  __typename?: 'Query';
  carSpecsCount: Scalars['Int'];
  carSpecsDistinct: Array<DistinctResult>;
  carSpecsFind: Array<CarSpec>;
  carSpecsFindOne?: Maybe<CarSpec>;
  distinctCarKeys: Array<DistinctCarKey>;
  geoQuery: Scalars['String'];
  listingsAggregates: ListingSearchAggregates;
  listingsCount: Scalars['Int'];
  listingsDistinct: Array<DistinctResult>;
  listingsFind: Array<Listing>;
  listingsFindOne?: Maybe<Listing>;
  listingsSearch: ListingSearchResult;
  listingsSearchRecent: Array<Listing>;
  makesCount: Scalars['Int'];
  makesDistinct: Array<DistinctResult>;
  makesFind: Array<Make>;
  makesFindOne?: Maybe<Make>;
  recaptchaVerify: RecaptchaResult;
  scrapesCount: Scalars['Int'];
  scrapesDistinct: Array<DistinctResult>;
  scrapesFind: Array<Scrape>;
  scrapesFindOne?: Maybe<Scrape>;
  usersCount: Scalars['Int'];
  usersDistinct: Array<DistinctResult>;
  usersFind: Array<User>;
  usersFindOne?: Maybe<User>;
  usersGetById: UserActionResult;
  zipCodesCount: Scalars['Int'];
  zipCodesDistinct: Array<DistinctResult>;
  zipCodesFind: Array<ZipCode>;
  zipCodesFindOne?: Maybe<ZipCode>;
};

export type QueryCarSpecsCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryCarSpecsDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryCarSpecsFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryCarSpecsFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryDistinctCarKeysArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  make?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGeoQueryArgs = {
  ipAddress: Scalars['String'];
};

export type QueryListingsAggregatesArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryListingsCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryListingsDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryListingsFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryListingsFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryListingsSearchArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryListingsSearchRecentArgs = {
  count: Scalars['Int'];
};

export type QueryMakesCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryMakesDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryMakesFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryMakesFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryRecaptchaVerifyArgs = {
  listingId: Scalars['String'];
  token: Scalars['String'];
};

export type QueryScrapesCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryScrapesDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryScrapesFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryScrapesFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryUsersCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryUsersDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryUsersFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryUsersFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryUsersGetByIdArgs = {
  id: Scalars['String'];
  login: Scalars['Boolean'];
};

export type QueryZipCodesCountArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type QueryZipCodesDistinctArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  keys: Array<Scalars['String']>;
};

export type QueryZipCodesFindArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']>>;
};

export type QueryZipCodesFindOneArgs = {
  filters?: InputMaybe<Array<FilterParam>>;
};

export type RecaptchaResult = {
  __typename?: 'RecaptchaResult';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  dateAdded: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  searchParams: Scalars['String'];
};

export type SavedSearchUpdate_Input = {
  dateAdded: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  searchParams: Scalars['String'];
};

export type Scrape = {
  __typename?: 'Scrape';
  children: ScrapeKey;
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  hasErrors?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  itemType: ScrapeItemType;
  make: Scalars['String'];
  model: Scalars['String'];
  properties?: Maybe<ScrapeProperty>;
  trim: Scalars['String'];
  url: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  year: Scalars['String'];
};

export type ScrapeAdd_Input = {
  children: ScrapeKey_Input;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  itemType: ScrapeItemType;
  make: Scalars['String'];
  model: Scalars['String'];
  properties?: InputMaybe<ScrapeProperty_Input>;
  trim: Scalars['String'];
  url: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
  year: Scalars['String'];
};

export enum ScrapeItemType {
  make = 'make',
  model = 'model',
  root = 'root',
  trim = 'trim',
  year = 'year',
}

export type ScrapeKey = {
  __typename?: 'ScrapeKey';
  url: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapeKey_Input = {
  url: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapeProperty = {
  __typename?: 'ScrapeProperty';
  category: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapeProperty_Input = {
  category: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ScrapeUpdate_Input = {
  children?: InputMaybe<ScrapeKey_Input>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  itemType?: InputMaybe<ScrapeItemType>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<ScrapeProperty_Input>;
  trim?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type Scrape_Add = {
  __typename?: 'Scrape_Add';
  children: ScrapeKey;
  hasErrors?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  itemType: ScrapeItemType;
  make: Scalars['String'];
  model: Scalars['String'];
  properties?: Maybe<ScrapeProperty>;
  trim: Scalars['String'];
  url: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  year: Scalars['String'];
};

export enum TransmissionType {
  automatic = 'automatic',
  cvt = 'cvt',
  manual = 'manual',
  na = 'na',
  other = 'other',
  unknown = 'unknown',
}

export type User = {
  __typename?: 'User';
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  favorites?: Maybe<Array<UserFavorite>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastLogin?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  savedSearches?: Maybe<Array<SavedSearch>>;
  verified: Scalars['Boolean'];
  zipCode?: Maybe<Scalars['String']>;
};

export enum UserActionCode {
  alreadyExists = 'alreadyExists',
  checked = 'checked',
  created = 'created',
  deleted = 'deleted',
  emailAlreadyVerified = 'emailAlreadyVerified',
  invalidPassword = 'invalidPassword',
  invalidVerificationCode = 'invalidVerificationCode',
  loggedIn = 'loggedIn',
  notFound = 'notFound',
  passwordChanged = 'passwordChanged',
  resetCodeSent = 'resetCodeSent',
  success = 'success',
  verificationCodeSent = 'verificationCodeSent',
  verified = 'verified',
}

export type UserActionResult = {
  __typename?: 'UserActionResult';
  code: UserActionCode;
  user?: Maybe<UserResult>;
};

export type UserAdd_Input = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastLogin?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UserFavorite = {
  __typename?: 'UserFavorite';
  dateAdded: Scalars['String'];
  id: Scalars['String'];
};

export type UserFavoriteUpdate_Input = {
  dateAdded: Scalars['String'];
  id: Scalars['String'];
};

export type UserResult = {
  __typename?: 'UserResult';
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  favorites?: Maybe<Array<UserFavorite>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastLogin?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  savedSearches?: Maybe<Array<SavedSearch>>;
  verified: Scalars['Boolean'];
  zipCode?: Maybe<Scalars['String']>;
};

export type UserUpdate_Input = {
  email?: InputMaybe<Scalars['String']>;
  favorites?: InputMaybe<Array<UserFavoriteUpdate_Input>>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastLogin?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  savedSearches?: InputMaybe<Array<SavedSearchUpdate_Input>>;
  verified?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ZipCode = {
  __typename?: 'ZipCode';
  city: Scalars['String'];
  code: Scalars['String'];
  county: Scalars['String'];
  dateAdded?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  deleteFlag?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  state: Scalars['String'];
};

export type ZipCodeAdd_Input = {
  city: Scalars['String'];
  code: Scalars['String'];
  county: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  state: Scalars['String'];
};

export type ZipCodeUpdate_Input = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
};

export type ZipCode_Add = {
  __typename?: 'ZipCode_Add';
  city: Scalars['String'];
  code: Scalars['String'];
  county: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  state: Scalars['String'];
};

export type DistinctCarKeysQueryVariables = Exact<{
  make?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type DistinctCarKeysQuery = {
  __typename?: 'Query';
  distinctCarKeys: Array<{
    __typename?: 'DistinctCarKey';
    year?: number | null;
    make?: string | null;
    model?: string | null;
  }>;
};

export type GeoQueryQueryVariables = Exact<{
  ipAddress: Scalars['String'];
}>;

export type GeoQueryQuery = { __typename?: 'Query'; geoQuery: string };

export type ListingsAddMutationVariables = Exact<{
  object: ListingAdd_Input;
}>;

export type ListingsAddMutation = { __typename?: 'Mutation'; listingsAdd: { __typename?: 'Listing'; id: string } };

export type ListingsDeleteMutationVariables = Exact<{
  listingsDeleteId: Scalars['String'];
}>;

export type ListingsDeleteMutation = { __typename?: 'Mutation'; listingsDelete: number };

export type ListingsUpdateMutationVariables = Exact<{
  object: ListingUpdate_Input;
}>;

export type ListingsUpdateMutation = {
  __typename?: 'Mutation';
  listingsUpdate: { __typename?: 'Listing'; id: string };
};

export type ListingsUploadImagesMutationVariables = Exact<{
  uploads: Array<ListingImageUpdate_Upload> | ListingImageUpdate_Upload;
}>;

export type ListingsUploadImagesMutation = {
  __typename?: 'Mutation';
  listingsUploadImages: Array<{ __typename?: 'ListingImage_UploadResult'; id: string; location: string }>;
};

export type ListingsContactSellerMutationVariables = Exact<{
  message: Scalars['String'];
  userId: Scalars['String'];
  listingId: Scalars['String'];
}>;

export type ListingsContactSellerMutation = { __typename?: 'Mutation'; listingsContactSeller: boolean };

export type ListingsAddViewMutationVariables = Exact<{
  listingId: Scalars['String'];
}>;

export type ListingsAddViewMutation = { __typename?: 'Mutation'; listingsAddView: number };

export type ListingsAggregatesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type ListingsAggregatesQuery = {
  __typename?: 'Query';
  listingsAggregates: {
    __typename?: 'ListingSearchAggregates';
    count?: number | null;
    yearMin?: number | null;
    yearMax?: number | null;
    priceMin?: number | null;
    priceMax?: number | null;
    mileageMin?: number | null;
    mileageMax?: number | null;
  };
};

export type ListingsSearchQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
  sortKeys?: InputMaybe<Array<Scalars['SortKey']> | Scalars['SortKey']>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type ListingsSearchQuery = {
  __typename?: 'Query';
  listingsSearch: {
    __typename?: 'ListingSearchResult';
    listings: Array<{
      __typename?: 'Listing';
      id: string;
      make: string;
      year: number;
      model: string;
      trimId: string;
      trim: string;
      heading: string;
      description: string;
      externalId?: string | null;
      bodyType: string;
      bodyTypeOther?: string | null;
      colorType: string;
      colorTypeOther?: string | null;
      conditionType: string;
      doorType: string;
      doorTypeOther?: string | null;
      drivetrainType: string;
      drivetrainTypeOther?: string | null;
      cylinderType: string;
      cylinderTypeOther?: string | null;
      fuelType: string;
      fuelTypeOther?: string | null;
      city?: string | null;
      state?: string | null;
      zipCode: string;
      showContactInfo?: boolean | null;
      listingDate: string;
      expireDate: string;
      deleteDate: string;
      status: string;
      statusDate: string;
      mileage: number;
      price: number;
      transmissionType: string;
      transmissionTypeOther?: string | null;
      titleStatus: string;
      userId: string;
      viewCount?: number | null;
      images: Array<{
        __typename?: 'ListingImage';
        id: string;
        location: string;
        external: boolean;
        primary: boolean;
        order: number;
      }>;
    }>;
    aggregates: {
      __typename?: 'ListingSearchAggregates';
      count?: number | null;
      yearMin?: number | null;
      yearMax?: number | null;
      priceMin?: number | null;
      priceMax?: number | null;
    };
  };
};

export type ListingsFindByUserQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type ListingsFindByUserQuery = {
  __typename?: 'Query';
  listingsFind: Array<{
    __typename?: 'Listing';
    heading: string;
    id: string;
    listingDate: string;
    expireDate: string;
    deleteDate: string;
    status: string;
    price: number;
    images: Array<{
      __typename?: 'ListingImage';
      id: string;
      location: string;
      external: boolean;
      primary: boolean;
      order: number;
    }>;
  }>;
};

export type ListingsSearchRecentQueryVariables = Exact<{
  count: Scalars['Int'];
}>;

export type ListingsSearchRecentQuery = {
  __typename?: 'Query';
  listingsSearchRecent: Array<{
    __typename?: 'Listing';
    id: string;
    make: string;
    year: number;
    model: string;
    trimId: string;
    trim: string;
    heading: string;
    description: string;
    externalId?: string | null;
    bodyType: string;
    bodyTypeOther?: string | null;
    colorType: string;
    colorTypeOther?: string | null;
    conditionType: string;
    doorType: string;
    doorTypeOther?: string | null;
    drivetrainType: string;
    drivetrainTypeOther?: string | null;
    cylinderType: string;
    cylinderTypeOther?: string | null;
    fuelType: string;
    fuelTypeOther?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode: string;
    showContactInfo?: boolean | null;
    listingDate: string;
    expireDate: string;
    deleteDate: string;
    status: string;
    statusDate: string;
    mileage: number;
    price: number;
    transmissionType: string;
    transmissionTypeOther?: string | null;
    titleStatus: string;
    userId: string;
    viewCount?: number | null;
    images: Array<{
      __typename?: 'ListingImage';
      id: string;
      location: string;
      external: boolean;
      primary: boolean;
      order: number;
    }>;
  }>;
};

export type RecaptchaVerifyQueryVariables = Exact<{
  listingId: Scalars['String'];
  token: Scalars['String'];
}>;

export type RecaptchaVerifyQuery = {
  __typename?: 'Query';
  recaptchaVerify: { __typename?: 'RecaptchaResult'; valid: boolean; email?: string | null; phone?: string | null };
};

export type UsersVerifyPasswordCodeMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['String'];
}>;

export type UsersVerifyPasswordCodeMutation = {
  __typename?: 'Mutation';
  usersVerifyPasswordCode: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersChangePasswordMutationVariables = Exact<{
  id: Scalars['String'];
  password: Scalars['String'];
}>;

export type UsersChangePasswordMutation = {
  __typename?: 'Mutation';
  usersChangePassword: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersAddFavoriteMutationVariables = Exact<{
  usersAddFavoriteId: Scalars['String'];
  listingId: Scalars['String'];
}>;

export type UsersAddFavoriteMutation = {
  __typename?: 'Mutation';
  usersAddFavorite: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersRemoveFavoriteMutationVariables = Exact<{
  usersRemoveFavoriteId: Scalars['String'];
  listingId: Scalars['String'];
}>;

export type UsersRemoveFavoriteMutation = {
  __typename?: 'Mutation';
  usersRemoveFavorite: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersUpdateMutationVariables = Exact<{
  object: UserUpdate_Input;
}>;

export type UsersUpdateMutation = {
  __typename?: 'Mutation';
  usersUpdate: {
    __typename?: 'User';
    dateAdded?: string | null;
    id: string;
    email: string;
    verified: boolean;
    firstName?: string | null;
    lastName?: string | null;
    zipCode?: string | null;
    lastLogin?: string | null;
    favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
    savedSearches?: Array<{
      __typename?: 'SavedSearch';
      id: string;
      name: string;
      searchParams: string;
      dateAdded: string;
    }> | null;
  };
};

export type UsersLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;

export type UsersLoginMutation = {
  __typename?: 'Mutation';
  usersLogin: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersRegisterMutationVariables = Exact<{
  object: UserAdd_Input;
}>;

export type UsersRegisterMutation = {
  __typename?: 'Mutation';
  usersRegister: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type UsersResetPasswordMutation = { __typename?: 'Mutation'; usersResetPassword: UserActionCode };

export type UsersDeleteMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type UsersDeleteMutation = { __typename?: 'Mutation'; usersDelete: number };

export type UsersCheckVerifiedMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type UsersCheckVerifiedMutation = {
  __typename?: 'Mutation';
  usersCheckVerified: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersVerifyEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type UsersVerifyEmailMutation = { __typename?: 'Mutation'; usersVerifyEmail: UserActionCode };

export type UsersVerifyEmailCodeMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['String'];
}>;

export type UsersVerifyEmailCodeMutation = {
  __typename?: 'Mutation';
  usersVerifyEmailCode: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersAddSavedSearchMutationVariables = Exact<{
  usersAddSavedSearchId: Scalars['String'];
  name: Scalars['String'];
  searchParams: Scalars['String'];
}>;

export type UsersAddSavedSearchMutation = {
  __typename?: 'Mutation';
  usersAddSavedSearch: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersRemoveSavedSearchMutationVariables = Exact<{
  itemId: Scalars['String'];
  userId: Scalars['String'];
}>;

export type UsersRemoveSavedSearchMutation = {
  __typename?: 'Mutation';
  usersRemoveSavedSearch: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type UsersGetByIdQueryVariables = Exact<{
  id: Scalars['String'];
  login: Scalars['Boolean'];
}>;

export type UsersGetByIdQuery = {
  __typename?: 'Query';
  usersGetById: {
    __typename?: 'UserActionResult';
    code: UserActionCode;
    user?: {
      __typename?: 'UserResult';
      dateAdded?: string | null;
      id: string;
      email: string;
      verified: boolean;
      firstName?: string | null;
      lastName?: string | null;
      zipCode?: string | null;
      lastLogin?: string | null;
      favorites?: Array<{ __typename?: 'UserFavorite'; id: string; dateAdded: string }> | null;
      savedSearches?: Array<{
        __typename?: 'SavedSearch';
        id: string;
        name: string;
        searchParams: string;
        dateAdded: string;
      }> | null;
    } | null;
  };
};

export type ZipCodesFindOneQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type ZipCodesFindOneQuery = {
  __typename?: 'Query';
  zipCodesFindOne?: {
    __typename?: 'ZipCode';
    code: string;
    city: string;
    state: string;
    latitude: number;
    longitude: number;
  } | null;
};

export type CarSpecsFindTrimQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type CarSpecsFindTrimQuery = {
  __typename?: 'Query';
  carSpecsFind: Array<{ __typename?: 'CarSpec'; id: string; trim: string }>;
};

export type CarSpecsFindTrimSpecsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FilterParam> | FilterParam>;
}>;

export type CarSpecsFindTrimSpecsQuery = {
  __typename?: 'Query';
  carSpecsFindOne?: {
    __typename?: 'CarSpec';
    bodyType: BodyType;
    cylinderType: CylinderType;
    doorType: DoorType;
    drivetrainType: DrivetrainType;
    fuelType: FuelType;
    transmissionType: TransmissionType;
  } | null;
};

export type MakesFindQueryVariables = Exact<{ [key: string]: never }>;

export type MakesFindQuery = {
  __typename?: 'Query';
  makesFind: Array<{ __typename?: 'Make'; id: string; name: string; popular?: boolean | null }>;
};

export const DistinctCarKeysDocument = gql`
  query distinctCarKeys($make: Boolean, $model: Boolean, $year: Boolean, $filters: [FilterParam!]) {
    distinctCarKeys(make: $make, model: $model, filters: $filters, year: $year) {
      year
      make
      model
    }
  }
`;

/**
 * __useDistinctCarKeysQuery__
 *
 * To run a query within a React component, call `useDistinctCarKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctCarKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistinctCarKeysQuery({
 *   variables: {
 *      make: // value for 'make'
 *      model: // value for 'model'
 *      year: // value for 'year'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDistinctCarKeysQuery(
  baseOptions?: Apollo.QueryHookOptions<DistinctCarKeysQuery, DistinctCarKeysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DistinctCarKeysQuery, DistinctCarKeysQueryVariables>(DistinctCarKeysDocument, options);
}
export function useDistinctCarKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DistinctCarKeysQuery, DistinctCarKeysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DistinctCarKeysQuery, DistinctCarKeysQueryVariables>(DistinctCarKeysDocument, options);
}
export type DistinctCarKeysQueryHookResult = ReturnType<typeof useDistinctCarKeysQuery>;
export type DistinctCarKeysLazyQueryHookResult = ReturnType<typeof useDistinctCarKeysLazyQuery>;
export type DistinctCarKeysQueryResult = Apollo.QueryResult<DistinctCarKeysQuery, DistinctCarKeysQueryVariables>;
export const GeoQueryDocument = gql`
  query GeoQuery($ipAddress: String!) {
    geoQuery(ipAddress: $ipAddress)
  }
`;

/**
 * __useGeoQueryQuery__
 *
 * To run a query within a React component, call `useGeoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoQueryQuery({
 *   variables: {
 *      ipAddress: // value for 'ipAddress'
 *   },
 * });
 */
export function useGeoQueryQuery(baseOptions: Apollo.QueryHookOptions<GeoQueryQuery, GeoQueryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GeoQueryQuery, GeoQueryQueryVariables>(GeoQueryDocument, options);
}
export function useGeoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoQueryQuery, GeoQueryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GeoQueryQuery, GeoQueryQueryVariables>(GeoQueryDocument, options);
}
export type GeoQueryQueryHookResult = ReturnType<typeof useGeoQueryQuery>;
export type GeoQueryLazyQueryHookResult = ReturnType<typeof useGeoQueryLazyQuery>;
export type GeoQueryQueryResult = Apollo.QueryResult<GeoQueryQuery, GeoQueryQueryVariables>;
export const ListingsAddDocument = gql`
  mutation ListingsAdd($object: ListingAdd_Input!) {
    listingsAdd(object: $object) {
      id
    }
  }
`;
export type ListingsAddMutationFn = Apollo.MutationFunction<ListingsAddMutation, ListingsAddMutationVariables>;

/**
 * __useListingsAddMutation__
 *
 * To run a mutation, you first call `useListingsAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsAddMutation, { data, loading, error }] = useListingsAddMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useListingsAddMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsAddMutation, ListingsAddMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsAddMutation, ListingsAddMutationVariables>(ListingsAddDocument, options);
}
export type ListingsAddMutationHookResult = ReturnType<typeof useListingsAddMutation>;
export type ListingsAddMutationResult = Apollo.MutationResult<ListingsAddMutation>;
export type ListingsAddMutationOptions = Apollo.BaseMutationOptions<ListingsAddMutation, ListingsAddMutationVariables>;
export const ListingsDeleteDocument = gql`
  mutation ListingsDelete($listingsDeleteId: String!) {
    listingsDelete(id: $listingsDeleteId)
  }
`;
export type ListingsDeleteMutationFn = Apollo.MutationFunction<ListingsDeleteMutation, ListingsDeleteMutationVariables>;

/**
 * __useListingsDeleteMutation__
 *
 * To run a mutation, you first call `useListingsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsDeleteMutation, { data, loading, error }] = useListingsDeleteMutation({
 *   variables: {
 *      listingsDeleteId: // value for 'listingsDeleteId'
 *   },
 * });
 */
export function useListingsDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsDeleteMutation, ListingsDeleteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsDeleteMutation, ListingsDeleteMutationVariables>(ListingsDeleteDocument, options);
}
export type ListingsDeleteMutationHookResult = ReturnType<typeof useListingsDeleteMutation>;
export type ListingsDeleteMutationResult = Apollo.MutationResult<ListingsDeleteMutation>;
export type ListingsDeleteMutationOptions = Apollo.BaseMutationOptions<
  ListingsDeleteMutation,
  ListingsDeleteMutationVariables
>;
export const ListingsUpdateDocument = gql`
  mutation ListingsUpdate($object: ListingUpdate_Input!) {
    listingsUpdate(object: $object) {
      id
    }
  }
`;
export type ListingsUpdateMutationFn = Apollo.MutationFunction<ListingsUpdateMutation, ListingsUpdateMutationVariables>;

/**
 * __useListingsUpdateMutation__
 *
 * To run a mutation, you first call `useListingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsUpdateMutation, { data, loading, error }] = useListingsUpdateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useListingsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsUpdateMutation, ListingsUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsUpdateMutation, ListingsUpdateMutationVariables>(ListingsUpdateDocument, options);
}
export type ListingsUpdateMutationHookResult = ReturnType<typeof useListingsUpdateMutation>;
export type ListingsUpdateMutationResult = Apollo.MutationResult<ListingsUpdateMutation>;
export type ListingsUpdateMutationOptions = Apollo.BaseMutationOptions<
  ListingsUpdateMutation,
  ListingsUpdateMutationVariables
>;
export const ListingsUploadImagesDocument = gql`
  mutation listingsUploadImages($uploads: [ListingImageUpdate_Upload!]!) {
    listingsUploadImages(uploads: $uploads) {
      id
      location
    }
  }
`;
export type ListingsUploadImagesMutationFn = Apollo.MutationFunction<
  ListingsUploadImagesMutation,
  ListingsUploadImagesMutationVariables
>;

/**
 * __useListingsUploadImagesMutation__
 *
 * To run a mutation, you first call `useListingsUploadImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsUploadImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsUploadImagesMutation, { data, loading, error }] = useListingsUploadImagesMutation({
 *   variables: {
 *      uploads: // value for 'uploads'
 *   },
 * });
 */
export function useListingsUploadImagesMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsUploadImagesMutation, ListingsUploadImagesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsUploadImagesMutation, ListingsUploadImagesMutationVariables>(
    ListingsUploadImagesDocument,
    options,
  );
}
export type ListingsUploadImagesMutationHookResult = ReturnType<typeof useListingsUploadImagesMutation>;
export type ListingsUploadImagesMutationResult = Apollo.MutationResult<ListingsUploadImagesMutation>;
export type ListingsUploadImagesMutationOptions = Apollo.BaseMutationOptions<
  ListingsUploadImagesMutation,
  ListingsUploadImagesMutationVariables
>;
export const ListingsContactSellerDocument = gql`
  mutation ListingsContactSeller($message: String!, $userId: String!, $listingId: String!) {
    listingsContactSeller(message: $message, userId: $userId, listingId: $listingId)
  }
`;
export type ListingsContactSellerMutationFn = Apollo.MutationFunction<
  ListingsContactSellerMutation,
  ListingsContactSellerMutationVariables
>;

/**
 * __useListingsContactSellerMutation__
 *
 * To run a mutation, you first call `useListingsContactSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsContactSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsContactSellerMutation, { data, loading, error }] = useListingsContactSellerMutation({
 *   variables: {
 *      message: // value for 'message'
 *      userId: // value for 'userId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingsContactSellerMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsContactSellerMutation, ListingsContactSellerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsContactSellerMutation, ListingsContactSellerMutationVariables>(
    ListingsContactSellerDocument,
    options,
  );
}
export type ListingsContactSellerMutationHookResult = ReturnType<typeof useListingsContactSellerMutation>;
export type ListingsContactSellerMutationResult = Apollo.MutationResult<ListingsContactSellerMutation>;
export type ListingsContactSellerMutationOptions = Apollo.BaseMutationOptions<
  ListingsContactSellerMutation,
  ListingsContactSellerMutationVariables
>;
export const ListingsAddViewDocument = gql`
  mutation ListingsAddView($listingId: String!) {
    listingsAddView(listingId: $listingId)
  }
`;
export type ListingsAddViewMutationFn = Apollo.MutationFunction<
  ListingsAddViewMutation,
  ListingsAddViewMutationVariables
>;

/**
 * __useListingsAddViewMutation__
 *
 * To run a mutation, you first call `useListingsAddViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingsAddViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingsAddViewMutation, { data, loading, error }] = useListingsAddViewMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingsAddViewMutation(
  baseOptions?: Apollo.MutationHookOptions<ListingsAddViewMutation, ListingsAddViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ListingsAddViewMutation, ListingsAddViewMutationVariables>(
    ListingsAddViewDocument,
    options,
  );
}
export type ListingsAddViewMutationHookResult = ReturnType<typeof useListingsAddViewMutation>;
export type ListingsAddViewMutationResult = Apollo.MutationResult<ListingsAddViewMutation>;
export type ListingsAddViewMutationOptions = Apollo.BaseMutationOptions<
  ListingsAddViewMutation,
  ListingsAddViewMutationVariables
>;
export const ListingsAggregatesDocument = gql`
  query ListingsAggregates($filters: [FilterParam!]) {
    listingsAggregates(filters: $filters) {
      count
      yearMin
      yearMax
      priceMin
      priceMax
      mileageMin
      mileageMax
    }
  }
`;

/**
 * __useListingsAggregatesQuery__
 *
 * To run a query within a React component, call `useListingsAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsAggregatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListingsAggregatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListingsAggregatesQuery, ListingsAggregatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsAggregatesQuery, ListingsAggregatesQueryVariables>(
    ListingsAggregatesDocument,
    options,
  );
}
export function useListingsAggregatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListingsAggregatesQuery, ListingsAggregatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsAggregatesQuery, ListingsAggregatesQueryVariables>(
    ListingsAggregatesDocument,
    options,
  );
}
export type ListingsAggregatesQueryHookResult = ReturnType<typeof useListingsAggregatesQuery>;
export type ListingsAggregatesLazyQueryHookResult = ReturnType<typeof useListingsAggregatesLazyQuery>;
export type ListingsAggregatesQueryResult = Apollo.QueryResult<
  ListingsAggregatesQuery,
  ListingsAggregatesQueryVariables
>;
export const ListingsSearchDocument = gql`
  query ListingsSearch($filters: [FilterParam!], $sortKeys: [SortKey!], $skip: Int, $limit: Int) {
    listingsSearch(filters: $filters, sortKeys: $sortKeys, skip: $skip, limit: $limit) {
      listings {
        id
        make
        year
        model
        trimId
        trim
        heading
        description
        externalId
        bodyType
        bodyTypeOther
        colorType
        colorTypeOther
        conditionType
        doorType
        doorTypeOther
        drivetrainType
        drivetrainTypeOther
        cylinderType
        cylinderTypeOther
        fuelType
        fuelTypeOther
        images {
          id
          location
          external
          primary
          order
        }
        city
        state
        zipCode
        showContactInfo
        listingDate
        expireDate
        deleteDate
        status
        statusDate
        mileage
        price
        transmissionType
        transmissionTypeOther
        titleStatus
        userId
        viewCount
      }
      aggregates {
        count
        yearMin
        yearMax
        priceMin
        priceMax
      }
    }
  }
`;

/**
 * __useListingsSearchQuery__
 *
 * To run a query within a React component, call `useListingsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sortKeys: // value for 'sortKeys'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListingsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<ListingsSearchQuery, ListingsSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsSearchQuery, ListingsSearchQueryVariables>(ListingsSearchDocument, options);
}
export function useListingsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListingsSearchQuery, ListingsSearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsSearchQuery, ListingsSearchQueryVariables>(ListingsSearchDocument, options);
}
export type ListingsSearchQueryHookResult = ReturnType<typeof useListingsSearchQuery>;
export type ListingsSearchLazyQueryHookResult = ReturnType<typeof useListingsSearchLazyQuery>;
export type ListingsSearchQueryResult = Apollo.QueryResult<ListingsSearchQuery, ListingsSearchQueryVariables>;
export const ListingsFindByUserDocument = gql`
  query ListingsFindByUser($filters: [FilterParam!]) {
    listingsFind(filters: $filters) {
      heading
      id
      listingDate
      expireDate
      deleteDate
      status
      price
      images {
        id
        location
        external
        primary
        order
      }
    }
  }
`;

/**
 * __useListingsFindByUserQuery__
 *
 * To run a query within a React component, call `useListingsFindByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsFindByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsFindByUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListingsFindByUserQuery(
  baseOptions?: Apollo.QueryHookOptions<ListingsFindByUserQuery, ListingsFindByUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsFindByUserQuery, ListingsFindByUserQueryVariables>(
    ListingsFindByUserDocument,
    options,
  );
}
export function useListingsFindByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListingsFindByUserQuery, ListingsFindByUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsFindByUserQuery, ListingsFindByUserQueryVariables>(
    ListingsFindByUserDocument,
    options,
  );
}
export type ListingsFindByUserQueryHookResult = ReturnType<typeof useListingsFindByUserQuery>;
export type ListingsFindByUserLazyQueryHookResult = ReturnType<typeof useListingsFindByUserLazyQuery>;
export type ListingsFindByUserQueryResult = Apollo.QueryResult<
  ListingsFindByUserQuery,
  ListingsFindByUserQueryVariables
>;
export const ListingsSearchRecentDocument = gql`
  query ListingsSearchRecent($count: Int!) {
    listingsSearchRecent(count: $count) {
      id
      make
      year
      model
      trimId
      trim
      heading
      description
      externalId
      bodyType
      bodyTypeOther
      colorType
      colorTypeOther
      conditionType
      doorType
      doorTypeOther
      drivetrainType
      drivetrainTypeOther
      cylinderType
      cylinderTypeOther
      fuelType
      fuelTypeOther
      images {
        id
        location
        external
        primary
        order
      }
      city
      state
      zipCode
      showContactInfo
      listingDate
      expireDate
      deleteDate
      status
      statusDate
      mileage
      price
      transmissionType
      transmissionTypeOther
      titleStatus
      userId
      viewCount
    }
  }
`;

/**
 * __useListingsSearchRecentQuery__
 *
 * To run a query within a React component, call `useListingsSearchRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsSearchRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsSearchRecentQuery({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useListingsSearchRecentQuery(
  baseOptions: Apollo.QueryHookOptions<ListingsSearchRecentQuery, ListingsSearchRecentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsSearchRecentQuery, ListingsSearchRecentQueryVariables>(
    ListingsSearchRecentDocument,
    options,
  );
}
export function useListingsSearchRecentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListingsSearchRecentQuery, ListingsSearchRecentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsSearchRecentQuery, ListingsSearchRecentQueryVariables>(
    ListingsSearchRecentDocument,
    options,
  );
}
export type ListingsSearchRecentQueryHookResult = ReturnType<typeof useListingsSearchRecentQuery>;
export type ListingsSearchRecentLazyQueryHookResult = ReturnType<typeof useListingsSearchRecentLazyQuery>;
export type ListingsSearchRecentQueryResult = Apollo.QueryResult<
  ListingsSearchRecentQuery,
  ListingsSearchRecentQueryVariables
>;
export const RecaptchaVerifyDocument = gql`
  query RecaptchaVerify($listingId: String!, $token: String!) {
    recaptchaVerify(listingId: $listingId, token: $token) {
      valid
      email
      phone
    }
  }
`;

/**
 * __useRecaptchaVerifyQuery__
 *
 * To run a query within a React component, call `useRecaptchaVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecaptchaVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecaptchaVerifyQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecaptchaVerifyQuery(
  baseOptions: Apollo.QueryHookOptions<RecaptchaVerifyQuery, RecaptchaVerifyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecaptchaVerifyQuery, RecaptchaVerifyQueryVariables>(RecaptchaVerifyDocument, options);
}
export function useRecaptchaVerifyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecaptchaVerifyQuery, RecaptchaVerifyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecaptchaVerifyQuery, RecaptchaVerifyQueryVariables>(RecaptchaVerifyDocument, options);
}
export type RecaptchaVerifyQueryHookResult = ReturnType<typeof useRecaptchaVerifyQuery>;
export type RecaptchaVerifyLazyQueryHookResult = ReturnType<typeof useRecaptchaVerifyLazyQuery>;
export type RecaptchaVerifyQueryResult = Apollo.QueryResult<RecaptchaVerifyQuery, RecaptchaVerifyQueryVariables>;
export const UsersVerifyPasswordCodeDocument = gql`
  mutation UsersVerifyPasswordCode($email: String!, $code: String!) {
    usersVerifyPasswordCode(email: $email, code: $code) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersVerifyPasswordCodeMutationFn = Apollo.MutationFunction<
  UsersVerifyPasswordCodeMutation,
  UsersVerifyPasswordCodeMutationVariables
>;

/**
 * __useUsersVerifyPasswordCodeMutation__
 *
 * To run a mutation, you first call `useUsersVerifyPasswordCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersVerifyPasswordCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersVerifyPasswordCodeMutation, { data, loading, error }] = useUsersVerifyPasswordCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUsersVerifyPasswordCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersVerifyPasswordCodeMutation, UsersVerifyPasswordCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersVerifyPasswordCodeMutation, UsersVerifyPasswordCodeMutationVariables>(
    UsersVerifyPasswordCodeDocument,
    options,
  );
}
export type UsersVerifyPasswordCodeMutationHookResult = ReturnType<typeof useUsersVerifyPasswordCodeMutation>;
export type UsersVerifyPasswordCodeMutationResult = Apollo.MutationResult<UsersVerifyPasswordCodeMutation>;
export type UsersVerifyPasswordCodeMutationOptions = Apollo.BaseMutationOptions<
  UsersVerifyPasswordCodeMutation,
  UsersVerifyPasswordCodeMutationVariables
>;
export const UsersChangePasswordDocument = gql`
  mutation UsersChangePassword($id: String!, $password: String!) {
    usersChangePassword(id: $id, password: $password) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersChangePasswordMutationFn = Apollo.MutationFunction<
  UsersChangePasswordMutation,
  UsersChangePasswordMutationVariables
>;

/**
 * __useUsersChangePasswordMutation__
 *
 * To run a mutation, you first call `useUsersChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersChangePasswordMutation, { data, loading, error }] = useUsersChangePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUsersChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersChangePasswordMutation, UsersChangePasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersChangePasswordMutation, UsersChangePasswordMutationVariables>(
    UsersChangePasswordDocument,
    options,
  );
}
export type UsersChangePasswordMutationHookResult = ReturnType<typeof useUsersChangePasswordMutation>;
export type UsersChangePasswordMutationResult = Apollo.MutationResult<UsersChangePasswordMutation>;
export type UsersChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  UsersChangePasswordMutation,
  UsersChangePasswordMutationVariables
>;
export const UsersAddFavoriteDocument = gql`
  mutation UsersAddFavorite($usersAddFavoriteId: String!, $listingId: String!) {
    usersAddFavorite(id: $usersAddFavoriteId, listingId: $listingId) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersAddFavoriteMutationFn = Apollo.MutationFunction<
  UsersAddFavoriteMutation,
  UsersAddFavoriteMutationVariables
>;

/**
 * __useUsersAddFavoriteMutation__
 *
 * To run a mutation, you first call `useUsersAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersAddFavoriteMutation, { data, loading, error }] = useUsersAddFavoriteMutation({
 *   variables: {
 *      usersAddFavoriteId: // value for 'usersAddFavoriteId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useUsersAddFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersAddFavoriteMutation, UsersAddFavoriteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersAddFavoriteMutation, UsersAddFavoriteMutationVariables>(
    UsersAddFavoriteDocument,
    options,
  );
}
export type UsersAddFavoriteMutationHookResult = ReturnType<typeof useUsersAddFavoriteMutation>;
export type UsersAddFavoriteMutationResult = Apollo.MutationResult<UsersAddFavoriteMutation>;
export type UsersAddFavoriteMutationOptions = Apollo.BaseMutationOptions<
  UsersAddFavoriteMutation,
  UsersAddFavoriteMutationVariables
>;
export const UsersRemoveFavoriteDocument = gql`
  mutation UsersRemoveFavorite($usersRemoveFavoriteId: String!, $listingId: String!) {
    usersRemoveFavorite(id: $usersRemoveFavoriteId, listingId: $listingId) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersRemoveFavoriteMutationFn = Apollo.MutationFunction<
  UsersRemoveFavoriteMutation,
  UsersRemoveFavoriteMutationVariables
>;

/**
 * __useUsersRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useUsersRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersRemoveFavoriteMutation, { data, loading, error }] = useUsersRemoveFavoriteMutation({
 *   variables: {
 *      usersRemoveFavoriteId: // value for 'usersRemoveFavoriteId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useUsersRemoveFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersRemoveFavoriteMutation, UsersRemoveFavoriteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersRemoveFavoriteMutation, UsersRemoveFavoriteMutationVariables>(
    UsersRemoveFavoriteDocument,
    options,
  );
}
export type UsersRemoveFavoriteMutationHookResult = ReturnType<typeof useUsersRemoveFavoriteMutation>;
export type UsersRemoveFavoriteMutationResult = Apollo.MutationResult<UsersRemoveFavoriteMutation>;
export type UsersRemoveFavoriteMutationOptions = Apollo.BaseMutationOptions<
  UsersRemoveFavoriteMutation,
  UsersRemoveFavoriteMutationVariables
>;
export const UsersUpdateDocument = gql`
  mutation UsersUpdate($object: UserUpdate_Input!) {
    usersUpdate(object: $object) {
      dateAdded
      id
      email
      verified
      firstName
      lastName
      zipCode
      lastLogin
      favorites {
        id
        dateAdded
      }
      savedSearches {
        id
        name
        searchParams
        dateAdded
      }
    }
  }
`;
export type UsersUpdateMutationFn = Apollo.MutationFunction<UsersUpdateMutation, UsersUpdateMutationVariables>;

/**
 * __useUsersUpdateMutation__
 *
 * To run a mutation, you first call `useUsersUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersUpdateMutation, { data, loading, error }] = useUsersUpdateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUsersUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersUpdateMutation, UsersUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersUpdateMutation, UsersUpdateMutationVariables>(UsersUpdateDocument, options);
}
export type UsersUpdateMutationHookResult = ReturnType<typeof useUsersUpdateMutation>;
export type UsersUpdateMutationResult = Apollo.MutationResult<UsersUpdateMutation>;
export type UsersUpdateMutationOptions = Apollo.BaseMutationOptions<UsersUpdateMutation, UsersUpdateMutationVariables>;
export const UsersLoginDocument = gql`
  mutation UsersLogin($email: String!, $password: String!) {
    usersLogin(email: $email, password: $password) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersLoginMutationFn = Apollo.MutationFunction<UsersLoginMutation, UsersLoginMutationVariables>;

/**
 * __useUsersLoginMutation__
 *
 * To run a mutation, you first call `useUsersLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersLoginMutation, { data, loading, error }] = useUsersLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUsersLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersLoginMutation, UsersLoginMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersLoginMutation, UsersLoginMutationVariables>(UsersLoginDocument, options);
}
export type UsersLoginMutationHookResult = ReturnType<typeof useUsersLoginMutation>;
export type UsersLoginMutationResult = Apollo.MutationResult<UsersLoginMutation>;
export type UsersLoginMutationOptions = Apollo.BaseMutationOptions<UsersLoginMutation, UsersLoginMutationVariables>;
export const UsersRegisterDocument = gql`
  mutation UsersRegister($object: UserAdd_Input!) {
    usersRegister(object: $object) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersRegisterMutationFn = Apollo.MutationFunction<UsersRegisterMutation, UsersRegisterMutationVariables>;

/**
 * __useUsersRegisterMutation__
 *
 * To run a mutation, you first call `useUsersRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersRegisterMutation, { data, loading, error }] = useUsersRegisterMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUsersRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersRegisterMutation, UsersRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersRegisterMutation, UsersRegisterMutationVariables>(UsersRegisterDocument, options);
}
export type UsersRegisterMutationHookResult = ReturnType<typeof useUsersRegisterMutation>;
export type UsersRegisterMutationResult = Apollo.MutationResult<UsersRegisterMutation>;
export type UsersRegisterMutationOptions = Apollo.BaseMutationOptions<
  UsersRegisterMutation,
  UsersRegisterMutationVariables
>;
export const UsersResetPasswordDocument = gql`
  mutation UsersResetPassword($email: String!) {
    usersResetPassword(email: $email)
  }
`;
export type UsersResetPasswordMutationFn = Apollo.MutationFunction<
  UsersResetPasswordMutation,
  UsersResetPasswordMutationVariables
>;

/**
 * __useUsersResetPasswordMutation__
 *
 * To run a mutation, you first call `useUsersResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersResetPasswordMutation, { data, loading, error }] = useUsersResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUsersResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersResetPasswordMutation, UsersResetPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersResetPasswordMutation, UsersResetPasswordMutationVariables>(
    UsersResetPasswordDocument,
    options,
  );
}
export type UsersResetPasswordMutationHookResult = ReturnType<typeof useUsersResetPasswordMutation>;
export type UsersResetPasswordMutationResult = Apollo.MutationResult<UsersResetPasswordMutation>;
export type UsersResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  UsersResetPasswordMutation,
  UsersResetPasswordMutationVariables
>;
export const UsersDeleteDocument = gql`
  mutation UsersDelete($id: String!) {
    usersDelete(id: $id)
  }
`;
export type UsersDeleteMutationFn = Apollo.MutationFunction<UsersDeleteMutation, UsersDeleteMutationVariables>;

/**
 * __useUsersDeleteMutation__
 *
 * To run a mutation, you first call `useUsersDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersDeleteMutation, { data, loading, error }] = useUsersDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersDeleteMutation, UsersDeleteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersDeleteMutation, UsersDeleteMutationVariables>(UsersDeleteDocument, options);
}
export type UsersDeleteMutationHookResult = ReturnType<typeof useUsersDeleteMutation>;
export type UsersDeleteMutationResult = Apollo.MutationResult<UsersDeleteMutation>;
export type UsersDeleteMutationOptions = Apollo.BaseMutationOptions<UsersDeleteMutation, UsersDeleteMutationVariables>;
export const UsersCheckVerifiedDocument = gql`
  mutation UsersCheckVerified($email: String!) {
    usersCheckVerified(email: $email) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersCheckVerifiedMutationFn = Apollo.MutationFunction<
  UsersCheckVerifiedMutation,
  UsersCheckVerifiedMutationVariables
>;

/**
 * __useUsersCheckVerifiedMutation__
 *
 * To run a mutation, you first call `useUsersCheckVerifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersCheckVerifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersCheckVerifiedMutation, { data, loading, error }] = useUsersCheckVerifiedMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUsersCheckVerifiedMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersCheckVerifiedMutation, UsersCheckVerifiedMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersCheckVerifiedMutation, UsersCheckVerifiedMutationVariables>(
    UsersCheckVerifiedDocument,
    options,
  );
}
export type UsersCheckVerifiedMutationHookResult = ReturnType<typeof useUsersCheckVerifiedMutation>;
export type UsersCheckVerifiedMutationResult = Apollo.MutationResult<UsersCheckVerifiedMutation>;
export type UsersCheckVerifiedMutationOptions = Apollo.BaseMutationOptions<
  UsersCheckVerifiedMutation,
  UsersCheckVerifiedMutationVariables
>;
export const UsersVerifyEmailDocument = gql`
  mutation UsersVerifyEmail($email: String!) {
    usersVerifyEmail(email: $email)
  }
`;
export type UsersVerifyEmailMutationFn = Apollo.MutationFunction<
  UsersVerifyEmailMutation,
  UsersVerifyEmailMutationVariables
>;

/**
 * __useUsersVerifyEmailMutation__
 *
 * To run a mutation, you first call `useUsersVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersVerifyEmailMutation, { data, loading, error }] = useUsersVerifyEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUsersVerifyEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersVerifyEmailMutation, UsersVerifyEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersVerifyEmailMutation, UsersVerifyEmailMutationVariables>(
    UsersVerifyEmailDocument,
    options,
  );
}
export type UsersVerifyEmailMutationHookResult = ReturnType<typeof useUsersVerifyEmailMutation>;
export type UsersVerifyEmailMutationResult = Apollo.MutationResult<UsersVerifyEmailMutation>;
export type UsersVerifyEmailMutationOptions = Apollo.BaseMutationOptions<
  UsersVerifyEmailMutation,
  UsersVerifyEmailMutationVariables
>;
export const UsersVerifyEmailCodeDocument = gql`
  mutation UsersVerifyEmailCode($email: String!, $code: String!) {
    usersVerifyEmailCode(email: $email, code: $code) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersVerifyEmailCodeMutationFn = Apollo.MutationFunction<
  UsersVerifyEmailCodeMutation,
  UsersVerifyEmailCodeMutationVariables
>;

/**
 * __useUsersVerifyEmailCodeMutation__
 *
 * To run a mutation, you first call `useUsersVerifyEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersVerifyEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersVerifyEmailCodeMutation, { data, loading, error }] = useUsersVerifyEmailCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUsersVerifyEmailCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersVerifyEmailCodeMutation, UsersVerifyEmailCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersVerifyEmailCodeMutation, UsersVerifyEmailCodeMutationVariables>(
    UsersVerifyEmailCodeDocument,
    options,
  );
}
export type UsersVerifyEmailCodeMutationHookResult = ReturnType<typeof useUsersVerifyEmailCodeMutation>;
export type UsersVerifyEmailCodeMutationResult = Apollo.MutationResult<UsersVerifyEmailCodeMutation>;
export type UsersVerifyEmailCodeMutationOptions = Apollo.BaseMutationOptions<
  UsersVerifyEmailCodeMutation,
  UsersVerifyEmailCodeMutationVariables
>;
export const UsersAddSavedSearchDocument = gql`
  mutation UsersAddSavedSearch($usersAddSavedSearchId: String!, $name: String!, $searchParams: String!) {
    usersAddSavedSearch(id: $usersAddSavedSearchId, name: $name, searchParams: $searchParams) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersAddSavedSearchMutationFn = Apollo.MutationFunction<
  UsersAddSavedSearchMutation,
  UsersAddSavedSearchMutationVariables
>;

/**
 * __useUsersAddSavedSearchMutation__
 *
 * To run a mutation, you first call `useUsersAddSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersAddSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersAddSavedSearchMutation, { data, loading, error }] = useUsersAddSavedSearchMutation({
 *   variables: {
 *      usersAddSavedSearchId: // value for 'usersAddSavedSearchId'
 *      name: // value for 'name'
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useUsersAddSavedSearchMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersAddSavedSearchMutation, UsersAddSavedSearchMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersAddSavedSearchMutation, UsersAddSavedSearchMutationVariables>(
    UsersAddSavedSearchDocument,
    options,
  );
}
export type UsersAddSavedSearchMutationHookResult = ReturnType<typeof useUsersAddSavedSearchMutation>;
export type UsersAddSavedSearchMutationResult = Apollo.MutationResult<UsersAddSavedSearchMutation>;
export type UsersAddSavedSearchMutationOptions = Apollo.BaseMutationOptions<
  UsersAddSavedSearchMutation,
  UsersAddSavedSearchMutationVariables
>;
export const UsersRemoveSavedSearchDocument = gql`
  mutation UsersRemoveSavedSearch($itemId: String!, $userId: String!) {
    usersRemoveSavedSearch(itemId: $itemId, userId: $userId) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;
export type UsersRemoveSavedSearchMutationFn = Apollo.MutationFunction<
  UsersRemoveSavedSearchMutation,
  UsersRemoveSavedSearchMutationVariables
>;

/**
 * __useUsersRemoveSavedSearchMutation__
 *
 * To run a mutation, you first call `useUsersRemoveSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersRemoveSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersRemoveSavedSearchMutation, { data, loading, error }] = useUsersRemoveSavedSearchMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersRemoveSavedSearchMutation(
  baseOptions?: Apollo.MutationHookOptions<UsersRemoveSavedSearchMutation, UsersRemoveSavedSearchMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UsersRemoveSavedSearchMutation, UsersRemoveSavedSearchMutationVariables>(
    UsersRemoveSavedSearchDocument,
    options,
  );
}
export type UsersRemoveSavedSearchMutationHookResult = ReturnType<typeof useUsersRemoveSavedSearchMutation>;
export type UsersRemoveSavedSearchMutationResult = Apollo.MutationResult<UsersRemoveSavedSearchMutation>;
export type UsersRemoveSavedSearchMutationOptions = Apollo.BaseMutationOptions<
  UsersRemoveSavedSearchMutation,
  UsersRemoveSavedSearchMutationVariables
>;
export const UsersGetByIdDocument = gql`
  query UsersGetById($id: String!, $login: Boolean!) {
    usersGetById(id: $id, login: $login) {
      code
      user {
        dateAdded
        id
        email
        verified
        firstName
        lastName
        zipCode
        lastLogin
        favorites {
          id
          dateAdded
        }
        savedSearches {
          id
          name
          searchParams
          dateAdded
        }
      }
    }
  }
`;

/**
 * __useUsersGetByIdQuery__
 *
 * To run a query within a React component, call `useUsersGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      login: // value for 'login'
 *   },
 * });
 */
export function useUsersGetByIdQuery(
  baseOptions: Apollo.QueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options);
}
export function useUsersGetByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options);
}
export type UsersGetByIdQueryHookResult = ReturnType<typeof useUsersGetByIdQuery>;
export type UsersGetByIdLazyQueryHookResult = ReturnType<typeof useUsersGetByIdLazyQuery>;
export type UsersGetByIdQueryResult = Apollo.QueryResult<UsersGetByIdQuery, UsersGetByIdQueryVariables>;
export const ZipCodesFindOneDocument = gql`
  query ZipCodesFindOne($filters: [FilterParam!]) {
    zipCodesFindOne(filters: $filters) {
      code
      city
      state
      latitude
      longitude
    }
  }
`;

/**
 * __useZipCodesFindOneQuery__
 *
 * To run a query within a React component, call `useZipCodesFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipCodesFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipCodesFindOneQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZipCodesFindOneQuery(
  baseOptions?: Apollo.QueryHookOptions<ZipCodesFindOneQuery, ZipCodesFindOneQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ZipCodesFindOneQuery, ZipCodesFindOneQueryVariables>(ZipCodesFindOneDocument, options);
}
export function useZipCodesFindOneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ZipCodesFindOneQuery, ZipCodesFindOneQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ZipCodesFindOneQuery, ZipCodesFindOneQueryVariables>(ZipCodesFindOneDocument, options);
}
export type ZipCodesFindOneQueryHookResult = ReturnType<typeof useZipCodesFindOneQuery>;
export type ZipCodesFindOneLazyQueryHookResult = ReturnType<typeof useZipCodesFindOneLazyQuery>;
export type ZipCodesFindOneQueryResult = Apollo.QueryResult<ZipCodesFindOneQuery, ZipCodesFindOneQueryVariables>;
export const CarSpecsFindTrimDocument = gql`
  query CarSpecsFindTrim($filters: [FilterParam!]) {
    carSpecsFind(filters: $filters) {
      id
      trim
    }
  }
`;

/**
 * __useCarSpecsFindTrimQuery__
 *
 * To run a query within a React component, call `useCarSpecsFindTrimQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarSpecsFindTrimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarSpecsFindTrimQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCarSpecsFindTrimQuery(
  baseOptions?: Apollo.QueryHookOptions<CarSpecsFindTrimQuery, CarSpecsFindTrimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarSpecsFindTrimQuery, CarSpecsFindTrimQueryVariables>(CarSpecsFindTrimDocument, options);
}
export function useCarSpecsFindTrimLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CarSpecsFindTrimQuery, CarSpecsFindTrimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarSpecsFindTrimQuery, CarSpecsFindTrimQueryVariables>(CarSpecsFindTrimDocument, options);
}
export type CarSpecsFindTrimQueryHookResult = ReturnType<typeof useCarSpecsFindTrimQuery>;
export type CarSpecsFindTrimLazyQueryHookResult = ReturnType<typeof useCarSpecsFindTrimLazyQuery>;
export type CarSpecsFindTrimQueryResult = Apollo.QueryResult<CarSpecsFindTrimQuery, CarSpecsFindTrimQueryVariables>;
export const CarSpecsFindTrimSpecsDocument = gql`
  query CarSpecsFindTrimSpecs($filters: [FilterParam!]) {
    carSpecsFindOne(filters: $filters) {
      bodyType
      cylinderType
      doorType
      drivetrainType
      fuelType
      transmissionType
    }
  }
`;

/**
 * __useCarSpecsFindTrimSpecsQuery__
 *
 * To run a query within a React component, call `useCarSpecsFindTrimSpecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarSpecsFindTrimSpecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarSpecsFindTrimSpecsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCarSpecsFindTrimSpecsQuery(
  baseOptions?: Apollo.QueryHookOptions<CarSpecsFindTrimSpecsQuery, CarSpecsFindTrimSpecsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarSpecsFindTrimSpecsQuery, CarSpecsFindTrimSpecsQueryVariables>(
    CarSpecsFindTrimSpecsDocument,
    options,
  );
}
export function useCarSpecsFindTrimSpecsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CarSpecsFindTrimSpecsQuery, CarSpecsFindTrimSpecsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarSpecsFindTrimSpecsQuery, CarSpecsFindTrimSpecsQueryVariables>(
    CarSpecsFindTrimSpecsDocument,
    options,
  );
}
export type CarSpecsFindTrimSpecsQueryHookResult = ReturnType<typeof useCarSpecsFindTrimSpecsQuery>;
export type CarSpecsFindTrimSpecsLazyQueryHookResult = ReturnType<typeof useCarSpecsFindTrimSpecsLazyQuery>;
export type CarSpecsFindTrimSpecsQueryResult = Apollo.QueryResult<
  CarSpecsFindTrimSpecsQuery,
  CarSpecsFindTrimSpecsQueryVariables
>;
export const MakesFindDocument = gql`
  query makesFind {
    makesFind {
      id
      name
      popular
    }
  }
`;

/**
 * __useMakesFindQuery__
 *
 * To run a query within a React component, call `useMakesFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useMakesFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMakesFindQuery({
 *   variables: {
 *   },
 * });
 */
export function useMakesFindQuery(baseOptions?: Apollo.QueryHookOptions<MakesFindQuery, MakesFindQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MakesFindQuery, MakesFindQueryVariables>(MakesFindDocument, options);
}
export function useMakesFindLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MakesFindQuery, MakesFindQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MakesFindQuery, MakesFindQueryVariables>(MakesFindDocument, options);
}
export type MakesFindQueryHookResult = ReturnType<typeof useMakesFindQuery>;
export type MakesFindLazyQueryHookResult = ReturnType<typeof useMakesFindLazyQuery>;
export type MakesFindQueryResult = Apollo.QueryResult<MakesFindQuery, MakesFindQueryVariables>;
